// extracted by mini-css-extract-plugin
module.exports = {"inlineMath":"styles_inlineMath__2dRCI","quillWrapper":"styles_quillWrapper__1wY5q"};